import type {
    ContactIdCompanyPair,
    ContactRevealByIdRequestDto,
    ContactsAllExportRequestDto,
    ContactsExportRequestDto,
    ContactsSearchResultsRequestDto,
} from "../types/dto";

import { numberToBoolean } from "./common";

type ExportArgs = {
    searchRequestDto: ContactsSearchResultsRequestDto;
    topNOrPairs: number | readonly ContactIdCompanyPair[];
};

export function createContactsExportRequestDto({
    searchRequestDto,
    topNOrPairs,
}: ExportArgs): ContactsExportRequestDto {
    let dto;

    if (typeof topNOrPairs === "number") {
        dto = {
            ...searchRequestDto,
            pageSize: topNOrPairs,
            top: topNOrPairs,
        };
    } else {
        // The contacts are named explicitly, so reveal-status filters must not narrow the result —
        // contacts revealed as part of the export flow no longer match "not revealed".
        dto = {
            ...searchRequestDto,
            includeContacts: topNOrPairs,
            includeOnlyNotRevealed: false,
        };
    }

    return dto;
}

export const createAllRevealedContactsExportDto = (): ContactsAllExportRequestDto => {
    return {
        device: "Total",
        includeOnlyExported: false,
        excludeExported: false,
        excludeUserLeads: false,
        includeOnlyNotRevealed: false,
        includeOnlyRevealed: true,
        isNewOnly: false,
        page: undefined,
        pageSize: undefined,
        queryFilters: {
            contactsFilters: {
                searchText: "",
            },
            leadsFilters: {},
        },
    };
};

export function createContactRevealByIdDto(selectedContactsIds: readonly string[]): ContactRevealByIdRequestDto[] {
    return selectedContactsIds.map((id: string) => {
        const [contactId, , , companyId, hasValidEmails, hasDirectPhoneNumbers, hasMobilePhoneNumbers, ...rest] =
            id.split(":");

        const [
            hasValidEmailsSuppressed = "0",
            hasMobilePhoneNumbersSuppressed = "0",
            hasDirectPhoneNumbersSuppressed = "0",
            prospect = rest[0],
        ] = rest.length === 1 ? ["0", "0", "0", rest[0]] : rest;

        return {
            contactId,
            prospect,
            companyId,
            hasValidEmails: numberToBoolean(hasValidEmails),
            hasValidEmailsSuppressed: numberToBoolean(hasValidEmailsSuppressed),
            hasDirectPhoneNumbers: numberToBoolean(hasDirectPhoneNumbers),
            hasDirectPhoneNumbersSuppressed: numberToBoolean(hasDirectPhoneNumbersSuppressed),
            hasMobilePhoneNumbers: numberToBoolean(hasMobilePhoneNumbers),
            hasMobilePhoneNumbersSuppressed: numberToBoolean(hasMobilePhoneNumbersSuppressed),
        };
    });
}
